var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14573_41438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6387 37.3746C40.5187 35.9879 36.6787 34.9746 32.332 34.9746C27.9854 34.9746 24.1454 36.0146 21.0254 37.3746C18.1454 38.6546 16.332 41.5346 16.332 44.6813V48.9746H48.332V44.6813C48.332 41.5346 46.5187 38.6546 43.6387 37.3746ZM21.852 43.6413C22.092 43.0279 22.572 42.5213 23.1587 42.2546C26.092 40.9479 29.1854 40.3079 32.3054 40.3079C35.452 40.3079 38.5187 40.9746 41.452 42.2546C42.0654 42.5213 42.5187 43.0279 42.7587 43.6413H21.852Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58536 39.8546C1.61203 40.7079 0.332031 42.6279 0.332031 44.7879V48.9746H12.332V44.6813C12.332 42.4679 12.9454 40.3879 14.012 38.5746C13.0254 38.4146 12.0387 38.3079 10.9987 38.3079C8.3587 38.3079 5.85203 38.8679 3.58536 39.8546Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0787 39.8546C58.812 38.8679 56.3054 38.3079 53.6654 38.3079C52.6254 38.3079 51.6387 38.4146 50.652 38.5746C51.7187 40.3879 52.332 42.4679 52.332 44.6813V48.9746H64.332V44.7879C64.332 42.6279 63.052 40.7079 61.0787 39.8546Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.332 32.9746C36.7587 32.9746 40.332 29.4013 40.332 24.9746C40.332 20.5479 36.7587 16.9746 32.332 16.9746C27.9054 16.9746 24.332 20.5479 24.332 24.9746C24.332 29.4013 27.9054 32.9746 32.332 32.9746ZM32.332 22.3079C33.7987 22.3079 34.9987 23.5079 34.9987 24.9746C34.9987 26.4413 33.7987 27.6413 32.332 27.6413C30.8654 27.6413 29.6654 26.4413 29.6654 24.9746C29.6654 23.5079 30.8654 22.3079 32.332 22.3079Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9984 23.6329L4.32341 30.3079L10.9984 36.983L17.6735 30.3079L10.9984 23.6329Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6654 24.9746L46.9987 35.6413H60.332L53.6654 24.9746Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14573_41438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.332031 0.974609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups3);
export default __webpack_public_path__ + "static/media/groups_3.aa23628c1d27b01683c63bb7b49f016d.svg";
export { ForwardRef as ReactComponent };